var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: " " },
    [
      _c("search-bar", {
        attrs: {
          close_search_action: "close_search_action",
          open_on_load: "true",
          min_input: _vm.min_input,
          label: _vm.setLabel()
        },
        on: {
          search_event: _vm.searchEvent,
          close_search_event: function($event) {
            _vm.closeSearch()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "transition-group",
            { attrs: { name: "fade", tag: "div" } },
            _vm._l(_vm.selected_users, function(selected_user, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "d-flex justify-content-between align-items-center"
                },
                [
                  _c("div", { staticClass: "d-inline-block" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(selected_user.email) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-inline-block btn btn-sm btn-primary",
                      on: {
                        click: function($event) {
                          _vm.removeUserFromSubmissionList(selected_user)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("delete")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.form_input !== ""
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: selected_user.id,
                            expression: "selected_user.id"
                          }
                        ],
                        attrs: { type: "hidden", name: _vm.form_input },
                        domProps: { value: selected_user.id },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(selected_user, "id", $event.target.value)
                          }
                        }
                      })
                    : _vm._e()
                ]
              )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm.searching === true ? _c("BaseLoadingAnimation") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.isEmpty(_vm.users)
          ? _c(
              "table",
              { staticClass: "table w-auto table-striped table-bordered" },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("First")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Last")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Email")]),
                    _vm._v(" "),
                    _vm.settings.show_roles
                      ? _c("th", [_vm._v("Roles")])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.users, function(user) {
                    return _c(
                      "tr",
                      {
                        class: {
                          "table-primary": _vm.userInSelected(user),
                          "cursor-pointer": _vm.userInSelected(user)
                        },
                        on: {
                          click: function($event) {
                            _vm.toggleUserToListSubmissionList(user)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(user.first_name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(user.last_name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(user.email))]),
                        _vm._v(" "),
                        _vm.settings.show_roles
                          ? _c(
                              "td",
                              _vm._l(user.roles, function(role) {
                                return _c("div", [
                                  _c("span", [
                                    _vm._v("[ " + _vm._s(role.name) + " ]")
                                  ])
                                ])
                              })
                            )
                          : _vm._e()
                      ]
                    )
                  })
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ed697d3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ed697d3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/forms/search/SearchUser.vue
// module id = 728
// module chunks = 0